import PreContractRequests from "app/api/pre-contract";
import { handleGenericApiError } from "app/api/error";
import { addLoading, removeLoading } from "./loading";
import { message } from "antd";
import { I18n } from "react-redux-i18n";

export const ACTION_SAVE_PRECONTRACTS = "precontract:ACTION_SAVE_PRECONTRACTS";
export const ACTION_SAVE_PRECONTRACTS_PER_CLIENT =
  "precontract:ACTION_SAVE_PRECONTRACTS_PER_CLIENT";

export const fetchPreContracts = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await PreContractRequests.fetchPreContracts(params);
    dispatch({ type: ACTION_SAVE_PRECONTRACTS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
export const fetchAllPreContracts = params => async () => {
  try {
    return await PreContractRequests.fetchPreContracts(params);
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const downloadPreContracts = params => async () => {
  if (
    params.searchParameter?.InitialPreContractDate &&
    params.searchParameter?.EndPreContractDate
  ) {
    var initialDate = params.searchParameter?.InitialPreContractDate.split(" ");
    var endDate = params.searchParameter?.EndPreContractDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        await PreContractRequests.downloadPreContracts(params.searchParameter);
        message.info(I18n.t("success.REQUEST_EXPORT_DATA"));
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const downloadConsolidatedPreContracts = params => async () => {
  if (
    params.searchParameter?.InitialPreContractDate &&
    params.searchParameter?.EndPreContractDate
  ) {
    var initialDate = params.searchParameter?.InitialPreContractDate.split(" ");
    var endDate = params.searchParameter?.EndPreContractDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response =
          await PreContractRequests.downloadPreContractsConsolidated(
            params.searchParameter
          );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "consolidados_simulacoes.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const fetchPreContractsConsolidade = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await PreContractRequests.fetchPreContractsConsolidade(params);
    dispatch({ type: ACTION_SAVE_PRECONTRACTS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
